




















import {
  // computed,
  defineComponent
} from '@vue/composition-api';
// import { EdgeMarkerType, MarkerProps, MarkerType } from '../../types';
// import { useWorkFlow } from '../../composables';
// import { getMarkerId } from '../../utils';
// import MarkerSymbols from './MarkerSymbols.vue';

export default defineComponent({
  name: 'MarkerDefinitions',
  components: {
    // MarkerSymbols
  }
  // setup() {
  // const {
  //   id: workFlowId,
  //   edges,
  //   connectionLineOptions,
  //   defaultMarkerColor: defaultColor
  // } = useWorkFlow();
  // const markers = computed(() => {
  //   const ids: Set<string> = new Set();
  //   const markers: MarkerProps[] = [];
  //   const createMarkers = (marker?: EdgeMarkerType) => {
  //     if (marker) {
  //       const markerId = getMarkerId(marker, workFlowId);
  //       if (!ids.has(markerId)) {
  //         if (typeof marker === 'object') {
  //           markers.push({
  //             ...marker,
  //             id: markerId,
  //             color: marker.color || defaultColor.value
  //           });
  //         } else {
  //           markers.push({
  //             id: markerId,
  //             color: defaultColor.value,
  //             type: marker as MarkerType
  //           });
  //         }
  //         ids.add(markerId);
  //       }
  //     }
  //   };
  //   for (const marker of [
  //     connectionLineOptions.value.markerEnd,
  //     connectionLineOptions.value.markerStart
  //   ]) {
  //     createMarkers(marker);
  //   }
  //   for (const edge of edges.value) {
  //     for (const marker of [edge.markerStart, edge.markerEnd]) {
  //       createMarkers(marker);
  //     }
  //   }
  //   return markers.sort((a, b) => a.id.localeCompare(b.id));
  // });
  // return { markers };
  // }
});
